itsoftApp.createModule("lazyLoading", function () {
    var module = this;
    /* Конфиг для ленивой занрузки изображений, фреймов, шрифтов и т.д. */
    var initLazy = function () {
        itsoftApp.loadScript("/assets/scripts/lazysizes/lazysizes.min.js", function () {
            window.lazySizesConfig = window.lazySizesConfig || {};
        });
    };

    initLazy();

    module.callback = initLazy;
});